<template>
  <slot></slot>
</template>

<script>
import { computed } from 'vue';
import { common as commonProps, tagging as taggingProps } from './prop-definitions';

const props = {
  ...commonProps,
  ...taggingProps,
};

export default {
  name: 'refapp-hotspots-provider',
  provide() {
    return Object.keys(props).reduce((acc, curr) => {
      acc[curr] = computed(() => this[curr]);
      return acc;
    }, {});
  },
  props,
};
</script>
